import { combineReducers, configureStore } from '@reduxjs/toolkit'
import companyReducer from '../features/companyid'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import userReducer from '../features/userid'
import activeInterviewedReducer from '../features/activeInterviewedTab'
import candidateTabReducer from '../features/candidateTab'
import sortedByReducer from '../features/sortedBy'
import  candidateFiltersReducer  from '../features/candidateFilters'
import paginationReducer from "../features/pagination"
import filtersReducer from '../features/jobCandidateStore'
import customPaginationReducer from '../features/paginationStore'
import dateFiltersReducer from "../features/dateFilterStore";
import drawerReducer from "../features/aiDrawerStore"; 

const persistConfig = {
    key: 'root',
    storage,
    blacklist : ["drawer"]
}

const rootReducer = combineReducers({
    companyid:companyReducer,
    userid:userReducer,
    candidateTab:candidateTabReducer,
    activeInterviewedTab:activeInterviewedReducer,
    sortedBy:sortedByReducer,
    candidateFilters:candidateFiltersReducer,
    pagination : paginationReducer,
    filters: filtersReducer,
    customPagination : customPaginationReducer,
    dateFilters: dateFiltersReducer,
    drawer : drawerReducer,
})
const persistedCompanyReducer = persistReducer(persistConfig, rootReducer,)



export const store = configureStore({
    reducer:persistedCompanyReducer

})

export const persistor = persistStore(store)